import { Observable } from 'rxjs';
import { Component, OnInit } from "@angular/core";
import { ConfigService } from "../shared/services/config.service";

@Component({
  selector: "app-social",
  templateUrl: "./social.component.html"
})
export class SocialComponent implements OnInit {
  socialsites$: Observable<any> = new Observable();

  constructor(private config: ConfigService) {}

  ngOnInit() {
    this.getSocialsites();
  }

  getSocialsites(): void {   
    this.socialsites$ = this.config.getSettings("websites");
  }
}
